import { useQuery } from "@tanstack/react-query";
import { fetchAllResources } from "@portal/env/hooks/fetchAllResources";

export function allResourcesQueryConfig(token, host) {
  return {
    queryKey: ['allResources'],
    queryFn: () => fetchAllResources(token, host),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  };
}

export function useAllResourcesQuery(token, host) {
  return useQuery(allResourcesQueryConfig(token, host));
}

export function useResourceQuery(resourceId, token, host) {
  const allResourcesQuery = useAllResourcesQuery(token, host);

  return useQuery({
    queryKey: ['resource', resourceId],
    queryFn: () => {
      const resource = allResourcesQuery.data?.find((r) => r.Id === resourceId);
      if (!resource) {
        throw new Error(`Resource with id ${resourceId} not found`);
      }
      return resource;
    },
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
    enabled: !!allResourcesQuery.data,
  });
}
